import { Outlet } from 'react-router-dom';
import AdminSubNav from '../../components/layout/AdminSubNav.jsx';

export default function AdminLayout() {
  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-8">
      <div className="mb-4">
        <h1 className="hxd-page-title">Admin</h1>
        <p className="text-[13px] text-hxd-muted mt-1.5">
          Operational settings for the newsletter pipeline.
        </p>
      </div>
      <AdminSubNav />
      <Outlet />
    </div>
  );
}
